import { Box, Flex } from '@sequencehq/core-components'
import { BillingTables } from './components/BillingTables'
import { CustomerMeta } from './components/CustomerMeta/CustomerMeta'
import { BillingScheduleTable } from './components/tables/BillingScheduleTable'
import { QuoteTable } from './components/tables/QuoteTable'
import { InvoiceSummaryStats } from 'components/Invoices/InvoiceSummaryStats/InvoiceSummaryStats'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'
import { useCustomerContext } from './hooks/useCustomerContext'
import { CustomerContactsLayout } from 'CustomerContacts/view/layout/CustomerContactsLayout'

export const CustomerOverviewPage = () => {
  const { customerId } = useParams<{ customerId: string }>()
  const { refetchCustomer } = useCustomerContext()
  const flags = useFeatureFlags()

  invariant(customerId, 'customerId is required')

  useEffect(() => {
    void refetchCustomer()
  }, [refetchCustomer])

  return (
    <Flex
      minWidth="1024px"
      height="100%"
      display="flex"
      justifyContent="center"
    >
      <Box maxWidth="1024px" width="100%">
        <Box p={4}>
          <InvoiceSummaryStats customerId={customerId} />
        </Box>
        <CustomerMeta />
        <CustomerContactsLayout />
        <BillingScheduleTable />
        <BillingTables />
        {flags.showQuoteBuilder && <QuoteTable />}
      </Box>
    </Flex>
  )
}
